import React, { useState } from 'react';

const PREVIEW_WORD_COUNT = 10;

export function ParagraphText(props) {
  const [expanded, setExpanded] = useState(false);

  const fullText = props.value == null ? '' : String(props.value);
  const words = fullText.trim().split(/\s+/);

  // The toggle is shown exactly when the preview hides something, so it can never
  // be missing for truncated text or shown when there is nothing more to reveal.
  const isTruncatable = words.length > PREVIEW_WORD_COUNT;
  const previewText = words.slice(0, PREVIEW_WORD_COUNT).join(' ');
  const displayedText = isTruncatable && !expanded ? previewText : fullText;

  const toggleClass = (event) => {
    event.preventDefault();
    setExpanded((prev) => !prev);
  };

  return (
    <div className="paragraph-text-wrapper">
      <div className="paragraph-content">{displayedText}</div>
      {isTruncatable && (
        <a href="#" onClick={toggleClass} className="show-toggle-more-less">
          <p className="toggle-link">{expanded ? 'show less' : 'show more'}</p>
        </a>
      )}
    </div>
  );
}

export default ParagraphText;
